// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-height:950px) and (orientation:landscape){.app-wrap{height:95vh!important}}html{font-size:62.5%;line-height:1.8;-webkit-hyphens:auto;hyphens:auto}@media screen and (min-height:640px){html{font-size:67.5%}}@media screen and (min-height:1024px){html{font-size:70%}}select{background-image:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
